export default "__VITE_ASSET__CAjD_q0$__"